export default __webpack_public_path__ + "static/media/logo-horizontal.2ba5724a.svg";